export default __webpack_public_path__ + "static/media/Krantideep-Singh.aa160d12.png";